/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_HeaderInputs */

const tr_landing_community_mock_header = /** @type {(inputs: Landing_Community_Mock_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# ShopPanel Topluluk`)
};

const en_landing_community_mock_header = /** @type {(inputs: Landing_Community_Mock_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# ShopPanel Community`)
};

const de_landing_community_mock_header = /** @type {(inputs: Landing_Community_Mock_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# ShopPanel Community`)
};

const ru_landing_community_mock_header = /** @type {(inputs: Landing_Community_Mock_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`# Сообщество ShopPanel`)
};

/**
* | output |
* | --- |
* | "# ShopPanel Community" |
*
* @param {Landing_Community_Mock_HeaderInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_header = /** @type {((inputs?: Landing_Community_Mock_HeaderInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_HeaderInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_header(inputs)
	if (locale === "de") return de_landing_community_mock_header(inputs)
	if (locale === "ru") return ru_landing_community_mock_header(inputs)
	return tr_landing_community_mock_header(inputs)
});